<template>
  <div>
    <v-select v-model="choiceValue" class="ma-5" :items="items" label="Select your action" outlined></v-select>
    <v-file-input v-if="isSetPropertiesComp" class="ma-5" v-model="files" color="primary" counter label="File input"
      prepend-icon="mdi-paperclip" outlined :show-size="1000">
      <template v-slot:selection="{ index, text }">
        <v-chip v-if="index < 2" color="primary" dark label small>
          {{ text }}
        </v-chip>
        <span v-else-if="index === 2" class="overline grey--text text--darken-3 mx-2">
          +{{ files.length - 2 }} File(s)
        </span>
      </template>
    </v-file-input>
    <p v-if="isErrorWhileParsing && isSetPropertiesComp" class="">
      Error while parsing file : not valid json file
    </p>
    <v-btn :disabled="!isButtonActive" @click="send" class="ma-5">
      Send {{ choiceValue }}
    </v-btn>
  </div>
</template>
<script>
export default {
  data: () => ({
    items: ["GetProperties", "SetProperties"],
    choiceValue: null,
    files: null,
    fileContent: null,
    isErrorWhileParsing: false,
    dataToSend: { params: null, setOrGet: null },
  }),
  methods: {
    send: function () {
      this.formatDatas();
      this.$emit("sendGetSetProperties", this.dataToSend);
    },
    formatDatas: function () {
      this.dataToSend.setOrGet =
        this.choiceValue === "GetProperties" ? "get" : "set";
      this.dataToSend.params = this.fileContent;
    },
    isSetProperties: function () {
      return this.choiceValue === "SetProperties";
    }
  },
  computed: {
    isButtonActive() {
      return (
        (this.value !== null && this.files != null && !this.isErrorWhileParsing) || (!this.isSetProperties() && this.choiceValue !== null)
      );
    },
    isSetPropertiesComp() {
      return this.isSetProperties();
    }
  },
  watch: {
    files() {
      if (this.files == null) {
        //console.log("user remove file");
      } else {
        var reader = new FileReader();
        // Use the javascript reader object to load the contents
        // of the file in the v-model prop
        reader.readAsText(this.files);
        reader.onload = () => {
          this.isErrorWhileParsing = false;
          try {
            this.dataToSend.params = null;
            let tmp = eval(reader.result);
            this.fileContent = tmp;
          } catch (error) {
            this.isErrorWhileParsing = true;
          }
        };
      }
    },
  },
};
</script>